import React from 'react';
import { Clock } from 'lucide-react';
import { openingHours } from '../data/mockData';

const OpeningHours = () => {
  return (
    <section className="py-20 px-4" style={{ background: 'linear-gradient(to bottom, #0A0015, #1A0520)' }}>
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 animate-fade-in-up">
          <Clock className="w-12 h-12 mx-auto mb-4 text-neon-pink animate-icon-pulse" style={{ filter: 'drop-shadow(0 0 10px #FF00FF)' }} />
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Öffnungszeiten Saale Lounge
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-neon-pink to-deep-violet mx-auto rounded-full" />
        </div>
        
        <div className="hours-table animate-fade-in-up delay-200">
          {openingHours.map((item) => (
            <div 
              key={item.day} 
              className={`hours-row flex justify-between items-center ${item.isClosed ? 'opacity-60' : ''}`}
            >
              <span className="text-white font-semibold text-lg" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {item.day}
              </span>
              <span 
                className={`text-lg ${item.isClosed ? 'text-white/60' : 'text-neon-pink'}`}
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: item.isClosed ? 400 : 600 }}
              >
                {item.hours}
              </span>
            </div>
          ))}
        </div>
        
        <div className="mt-8 text-center animate-fade-in-up delay-400">
          <p className="text-white/70 text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            * An Feiertagen können abweichende Öffnungszeiten gelten
          </p>
        </div>
      </div>
    </section>
  );
};

export default OpeningHours;
